<template>
  <div>
    <div class="demo-drawer__content data_action_form">
      <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
        <v-tabs :type="99" :activeName="'不良事件监测报告表'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm"
          @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
          <template slot="tabs" slot-scope="scope">
            <div v-if="scope.index == 0">
              <table style="width: 96vw;overflow: scroll; background-color: white; border-color: #ccc;border-radius: 3px;" border="1"
                cellpadding="0" cellspacing="0">
                <tr>
                  <td style="border: none;" class="title">
                    <h1 style="text-align: center;">不良事件监测报告表</h1>
                  </td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_2">企业名称</td>
                  <td class="flex_4"> <el-input size="mini" v-model="tableInfo.enterpriseName"></el-input></td>
                  <td class="flex_2">电话</td>
                  <td class="flex_6"><el-input size="mini" v-model="tableInfo.enterprisePhone"></el-input></td>
                  <td class="flex_4">报告日期及时间</td>
                  <td class="flex_6"><el-date-picker  v-model="tableInfo.reportTime" value-format="timestamp"
                      type="datetime" placeholder="选择日期时间">
                    </el-date-picker></td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_2">患者姓名</td>
                  <td class="flex_1"><el-input size="mini" v-model="tableInfo.patientName"></el-input></td>
                  <td class="flex_2">性别</td>
                  <td class="flex_2"><el-input size="mini" v-model="tableInfo.patientSex"></el-input></td>
                  <td class="flex_2">出生日期</td>
                  <td class="flex_2"><el-date-picker v-model="tableInfo.patientBirthday" value-format="timestamp"
                      type="date" placeholder="选择日期">
                    </el-date-picker></td>
                  <td class="flex_2">民族</td>
                  <td class="flex_2"><el-input size="mini" v-model="tableInfo.patientNation"></el-input></td>
                  <td class="flex_4">既往类似不良事件</td>
                  <td class="flex_5">
                    <el-radio v-model="tableInfo.isBadness" label="0">有</el-radio>
                    <el-radio v-model="tableInfo.isBadness" label="1">无</el-radio>
                    <el-radio v-model="tableInfo.isBadness" label="2">不良</el-radio>
                  </td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">病历号/门诊号</td>
                  <td class="flex_2"><el-input size="mini" v-model="tableInfo.outpatientNumber"></el-input></td>
                  <td class="flex_3">工作单位或住址</td>
                  <td class="flex_10"><el-input size="mini" v-model="tableInfo.address"></el-input></td>
                  <td class="flex_1">电话</td>
                  <td class="flex_5"><el-input size="mini" v-model="tableInfo.patientPhone"></el-input></td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">原患疾病</td>
                  <td class="flex_21"><el-input size="mini" v-model="tableInfo.primaryDisease"></el-input></td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">不良事件名称</td>
                  <td class="flex_8"><el-input size="mini" v-model="tableInfo.badnessName"></el-input></td>
                  <td class="flex_6">不良事件发生时间</td>
                  <td class="flex_7"><el-date-picker v-model="tableInfo.badnessTime" value-format="timestamp"
                      type="datetime" placeholder="选择日期时间">
                    </el-date-picker></td>
                </tr>
                <tr class="tr_flex" style="height: 84px;line-height: 24px;">
                  <td class="flex_3">
                    不良事件的表现(包括临床检验)
                  </td>
                  <td class="flex_21"><el-input type="textarea" style="border: 0;" :rows="4" size="mini"
                      v-model="tableInfo.expression"></el-input></td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">不良事件处理情况</td>
                  <td class="flex_21"><el-input size="mini" v-model="tableInfo.handSituation"></el-input></td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">使用情况</td>
                  <td class="flex_7"><el-input size="mini" v-model="tableInfo.useSituation"></el-input></td>
                  <td class="flex_4">产品贮存流通情况</td>
                  <td class="flex_4"><el-input size="mini" v-model="tableInfo.circulateSituation"></el-input></td>
                  <td class="flex_3">患者诊治情况</td>
                  <td class="flex_3"><el-input size="mini" v-model="tableInfo.diagnoseSituation"></el-input></td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">不良事件的结果</td>
                  <td class="flex_21">
                    <el-radio v-model="tableInfo.badnessResult" label="0">严重伤害</el-radio>
                    <el-radio v-model="tableInfo.badnessResult" label="1">死亡</el-radio>
                    <el-radio v-model="tableInfo.badnessResult" label="2">群体事件</el-radio>
                  </td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">对原患疾病的影响</td>
                  <td class="flex_15">
                    <el-radio v-model="tableInfo.influenceType" label="0">不明显</el-radio>
                    <el-radio v-model="tableInfo.influenceType" label="1">病程延长</el-radio>
                    <el-radio v-model="tableInfo.influenceType" label="2">病情加重</el-radio>
                    <el-radio v-model="tableInfo.influenceType" label="3">导致后遗症</el-radio>
                  </td>
                  <td class="flex_2">表现</td>
                  <td class="flex_4"><el-input size="mini" v-model="tableInfo.influenceDesc"></el-input></td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_5">关联性评价省级ADR监测机构</td>
                  <td class="flex_19">
                    <el-radio v-model="tableInfo.provinceEvaluate" label="0">肯定</el-radio>
                    <el-radio v-model="tableInfo.provinceEvaluate" label="1">很可能</el-radio>
                    <el-radio v-model="tableInfo.provinceEvaluate" label="2">可能</el-radio>
                    <el-radio v-model="tableInfo.provinceEvaluate" label="3">不大可能</el-radio>
                    <el-radio v-model="tableInfo.provinceEvaluate" label="4">未评价</el-radio>
                    <el-radio v-model="tableInfo.provinceEvaluate" label="5">无法评价</el-radio>
                  </td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_5">国家ADR监测中心</td>
                  <td class="flex_19">
                    <el-radio v-model="tableInfo.nationEvaluate" label="0">肯定</el-radio>
                    <el-radio v-model="tableInfo.nationEvaluate" label="1">很可能</el-radio>
                    <el-radio v-model="tableInfo.nationEvaluate" label="2">可能</el-radio>
                    <el-radio v-model="tableInfo.nationEvaluate" label="3">不大可能</el-radio>
                    <el-radio v-model="tableInfo.nationEvaluate" label="4">未评价</el-radio>
                    <el-radio v-model="tableInfo.nationEvaluate" label="5">无法评价</el-radio>
                  </td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_24">曾在国内、外发生的不良事件情况(包括报刊杂志报道情况)</td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">国内</td>
                  <td class="flex_21">
                    <el-input size="mini" v-model="tableInfo.nationReport"></el-input>
                  </td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">国外</td>
                  <td class="flex_21">
                    <el-input size="mini" v-model="tableInfo.abroadReport"></el-input>
                  </td>
                </tr>
                <tr class="tr_flex">
                  <td class="flex_3">其它</td>
                  <td class="flex_21">
                    <el-input size="mini" v-model="tableInfo.otherReport"></el-input>
                  </td>
                </tr>
                <tr class="">
                  <div style="padding: 5px;"><el-button @click="addDetail" size="mini" type="primary"
                      style="margin-left: 10px;">
                      新增明细</el-button>
                    <el-button size="mini" @click="delDetail" type="danger" style="margin-left: 10px;">
                      删除明细</el-button>
                  </div>
                  <el-table class="baseTable" ref="mxTableRef" :data="tableInfo.detailList" border size="mini"
                    :key="tableKey" height="400">
                    <el-table-column width="80" label="选择">
                      <template slot-scope="scope">
                        <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                          <i class="el-icon-thumb"></i>
                        </el-radio>
                      </template>
                    </el-table-column>
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="bgmName" label="通用名称" align="center" min-width="160">
                      <template slot-scope="scope">
                        <el-input class="bgmInput" ref="bgmName" clearable
                          @keyup.enter.native="openSearch('7067112496762880', scope.$index, 'bgmName')"
                          v-model="tableInfo.detailList[scope.$index].bgmName">
                          <el-button @click="openSearch('7067112496762880', scope.$index, 'bgmName')" slot="append"
                            icon="el-icon-search">
                          </el-button>
                        </el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="manufacturer" label="生产厂家" align="center" min-width="160" />
                    <el-table-column prop="bgiRegistno" label="注册证号/备案凭证号" align="center" min-width="140" />
                    <el-table-column prop="batchno" label="批号" align="center" min-width="120" />
                    <el-table-column prop="spec" label="规格/型号" align="center" min-width="120" />
                  </el-table>
                </tr>
              </table>
              <div style="display: flex;padding-left: 50%;">
                <div style="display: flex;"><span style="display: block;width: 60px;">职务:</span>
                  <el-input size="mini" v-model="tableInfo.job"></el-input>
                </div>
                <div style="display: flex;"> <span style="display: block;width: 140px;">报告人签名:</span>
                  <el-input size="mini" v-model="tableInfo.signature"></el-input>
                </div>
              </div>
            </div>
          </template>
        </v-tabs>
      </el-card>

      <div class="foot">
        <div style="text-align: center;">
          <el-button type="primary" @click="initActionBox">取消</el-button>
          <el-button type="primary" v-if="eventType == 0" @click="submitInfo">保存</el-button>
          <el-button type="primary" v-if="eventType == 1" @click="submitInfo">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
      :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
      <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData"
        @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: "xsbadnessReportAction",
  props: ["actionData"],
  data() {
    //这里存放数据
    return {
      tableKey: 0,
      parentSearchData: {},
      seTitle: "", //检索
      seWidth: "",
      DialogVisible: false,
      seId: 0,
      seIndex: 0,
      selectedDetailsIndex: 0,
      tableInfo: {
        abroadReport: '',//	国外历史不良情况	
        address: '',//	工作单位或住址		
        badnessName: '',//不良事件名称	
        badnessResult: '',//不良事件的结果
        badnessTime: '',//不良事件发生时间	
        circulateSituation: '',//产品贮存流通情况
        diagnoseSituation: '',//患者诊治情况
        detailList: [
        ],
        enterpriseName: '',//企业名称
        patientBirthday: '',//出生日期
        enterprisePhone: '',//企业电话
        expression: '',//不良事件的表现（包括临床检验）
        handSituation: '',//不良事件处理情况	
        influenceDesc: '',//影响表现
        influenceType: 0,//对原患疾病的影响0不明显1.病程延长2.病情家中3.导致后遗症	
        isBadness: 0,//既往类似不良事件0.有1.无2.不良
        job: '',//职业
        nationEvaluate: 0,//	国家ADR监测中心监测机构0.肯定1.很可能2.不大可能3.未评价4.无法评价
        nationReport: '',//国内历史不良情况	
        ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId,//	组织ID
        otherReport: '',//其它不良情况
        outpatientNumber: '',//病历号/门诊号	
        patientName: '',//患者姓名
        patientNation: '',//	患者民族
        patientPhone: '',//患者电话
        patientSex: '',//患者性别
        primaryDisease: '',//原患疾病
        provinceEvaluate: 0,//关联性评价省级ADR监测机构0.肯定1.很可能2.不大可能3.未评价4.无法评价
        reportTime: '',//报告日期及时间	
        signature: '',//	报告人签名
        useSituation: ''//使用情况		
      },
      tabForm: [
        {
          jciName: "不良事件监测报告表",
          jurconfigform: [],
        }
      ],
      mxHeight: 0,
      eventType: 0
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getBtnHeight()
    
    this.$nextTick(() => {
      this.openBox()
    });

  },
  //方法集合
  methods: {
    //获取检索方案宽度
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    openBox() {
      for (let key in this.actionData.oldData) {
        this.tableInfo[key] = this.actionData.oldData[key]
      }
      this.eventType = this.actionData.cate
      if(this.eventType==0){
        this.tableInfo['detailList'] = []
      }
    },
    //获取检索方案名字
    getSearchName(e) {
      this.seTitle = e;
    },
    //保存
    submitInfo() {
      if (this.eventType == 0) {
        this.$http.addBadness(this.tableInfo).then(res => {
          if (res.status == 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("drawerCancel");
            this.initData();
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (this.eventType == 1) {
        this.$http.updateBadness(this.tableInfo).then(res => {
          if (res.status == 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("drawerCancel");
            this.initData();
          } else {
            this.$message.error(res.message)
          }
        })
      }

    },
    //打开检索方案
    openSearch(sId, index, type) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.parentSearchData[type] = this.tableInfo.detailList[index][type] || '';

    },
    //检索带回数据,
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.tableInfo.detailList[this.seIndex] = val
        this.tableKey++
        this.DialogVisible = false;
        console.log(this.tableInfo.detailList);
      }
    },
    //关闭检索方案
    closeChild() {
      this.parentSearchData.bgmId = "";
      this.parentSearchData.bgmName = "";
    },
    //新增明细
    addDetail() {
      this.tableInfo.detailList.push({})
    },
    //删除明细
    delDetail() {
      this.tableInfo.detailList.splice(this.selectedDetailsIndex, 1)
    },
    async getBtnHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.mxHeight = this.$common.getBtnHeight()
        }, 16.7)
      })

    },
    //取消
    initActionBox() {
      this.$emit("drawerCancel");
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='css' scoped>
*{
  box-sizing: border-box;
}
.tr_flex {
  display: flex;
  height: 28px;
}

td {
  padding-left: 2px;
  overflow: hidden;
}

.flex_1 {
  width: 4vw;
}

.flex_2 {
  width: 8vw;
}

.flex_3 {
  width: 12vw;
}

.flex_4 {
  width: 16vw;
}

.flex_5 {
  width: 20vw;
}

.flex_6 {
  width: 24vw;
}

.flex_7 {
  width: 28vw;
}

.flex_8 {
  width: 32vw;
}

.flex_10 {
  width: 40vw;

}

.flex_15 {
  width: 60vw;

}

.flex_18 {
  width: 72vw;
}

.flex_19 {
  width: 76vw;

}

.flex_21 {
  width: 84vw;
}

.flex_24 {
  width: 96vw;

}

::v-deep .el-input__inner {
  border: none;
  padding: 0;
  height: 28px;
}

::v-deep .bgmInput>.el-input__inner {
  border: 1px solid #DCDFE6 !important;
  padding: 0 5px;
  height: 28px;
}

::v-deep .el-icon-date:before {
    content: '';
}

::v-deep .el-icon-time:before {
  content: '';
}
::v-deep .el-input--prefix .el-input__inner {
    padding-left: 0;
}
::v-deep .yellow .el-input__inner {
  background-color: #faffbd;
}
</style>
